UpdateNotificationCtrl.$inject = ['$scope', '$window', 'VersionServ']

export default function UpdateNotificationCtrl($scope, $window, VersionServ) {

  $scope.versionServ = VersionServ;

  $scope.reload = () => {
    $window.location.reload();
  };

};



// WEBPACK FOOTER //
// ./project/directives/lf-update-notification/lf-update-notification.controller.js